
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ErrorCode } from '@/common/ErrorCode';

interface Error {
  title: string;
  body: string;
  helperText?: string;
}

const errors: Record<ErrorCode | 'default', Error> = {
  [ErrorCode.NotAuthorized]: {
    title: `Access denied`,
    body: `You do not have permission to access this page.`
  },
  [ErrorCode.NotFound]: {
    title: 'Page not found',
    body: `The page you are looking for does not exist.`
  },
  [ErrorCode.InvalidOrganisation]: {
    title: 'Access denied',
    body: `You do not have access to the application because you are not a member of the associated organisation.`,
    helperText: 'Please make sure the url you used is correct, and that you have a valid login.'
  },
  default: {
    title: 'Error',
    body: `Something went wrong.`
  }
} as const;

@Component({})
export default class ErrorPage extends Vue {
  @Prop({ required: false })
  private code!: keyof typeof errors | undefined;

  get error(): Error {
    if (this.code && errors[this.code]) {
      return errors[this.code];
    } else {
      return errors.default;
    }
  }
}
